import { Model } from '../general'

import { Address } from './address'

export interface Data {
  id: number
  company_id: number
  location_id: number
  name?: string
  address?: Address
  nr_of_workspaces?: number
  nr_of_floors?: number
  src?: string
}

class Building extends Model<Data> {
  get companyId() {
    return this.data.company_id
  }

  get locationId() {
    return this.data.location_id
  }

  get name() {
    return this.data.name
  }

  get addressLine1() {
    return this.data.address?.address_line_1
  }

  get addressLine2() {
    return this.data.address?.address_line_2
  }

  get city() {
    return this.data.address?.city
  }

  get zipCode() {
    return this.data.address?.zipcode
  }

  get countryCode() {
    return this.data.address?.country_code
  }

  get timeZoneId() {
    return this.data.address?.time_zone
  }

  get searchText(): string {
    return `${this.name}`
  }

  get numberOfFloors() {
    return this.data.nr_of_floors
  }

  get numberOfWorkspaces() {
    return this.data.nr_of_workspaces
  }

  get src() {
    return this.data.src
  }

  get displayAddress() {
    if (!this.addressLine1 || !this.zipCode || !this.city) return ''
    return `${this.addressLine1}, ${this.zipCode} ${this.city}`
  }

  get latitude() {
    return this.data.address?.latitude
  }
  get longitude() {
    return this.data.address?.longitude
  }
}

export default Building
